import familiadosApiClient from '$utils/familiadosApiClient'
import { apiErrorService } from '$utils/services/apiErrorService'
import { apiRouter } from '$domain/model/apiRouter'
import { CaretakerDetailsInfoProDto, InfoDiscountCouponDto } from '$domain/model/pro/pro.model'
import {
  mapCaretakerDetailsInfoProDtoToView,
  mapInfoDiscountCouponDtoToView,
  mapProSubscriptionUpdatePaymentMethodToDto,
} from '$domain/model/pro/pro.mapper'

export const getCaretakerDetailsInfoPro = async () => {
  try {
    const detailsInfoPro = await familiadosApiClient.get<CaretakerDetailsInfoProDto>(
      apiRouter.getCaretakerDetailsInfoProPath(),
    )
    return mapCaretakerDetailsInfoProDtoToView(detailsInfoPro)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const cancelProSubscription = async () => {
  try {
    await familiadosApiClient.post(apiRouter.getCancelProSubscriptionPath())
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const checkCouponValidity = async (couponCode: string) => {
  try {
    const infoCoupon = await familiadosApiClient.post<InfoDiscountCouponDto>(
      apiRouter.getCheckProCouponValidityPath(),
      {
        couponCode,
      },
    )
    return mapInfoDiscountCouponDtoToView(infoCoupon)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const updatePaymentMethod = async (paymentMethodId: string) => {
  try {
    const newPaymentMethodId = mapProSubscriptionUpdatePaymentMethodToDto(paymentMethodId)
    await familiadosApiClient.post(apiRouter.getProSubscriptionUpdatePaymentMethodPath(), newPaymentMethodId)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/pro/pro.manager.ts